class ObstetricalResourcesDepressionScreening {
    public DepressionScreeningDate?: Date;
    public DisinterestScore?: number;
    public DepressedScore?: number;

    constructor(fields?: Partial<ObstetricalResourcesDepressionScreening>) {
        Object.assign(this, fields);
    }

    public get TotalScore(): number {
        if (this.DisinterestScore == null && this.DepressedScore == null)
            return null;

        return (this.DisinterestScore ?? 0) + (this.DepressedScore ?? 0);
    }
}

export { ObstetricalResourcesDepressionScreening };
